import { defineMessages } from 'react-intl';

export default defineMessages({
    edit: {
        id: '_.select_with_search.edit',
        defaultMessage: 'Edit'
    },
    noResultsFound: {
        id: '_.select_with_search.no_results_found',
        defaultMessage: 'No results found'
    }
});
